import { FC, useContext } from 'react';

import Accordion, { AccordionItem } from '@ingka/accordion';
import { t } from '@onlinepayments/payments-library';

import { OrderDetailsContext } from '../../OrderDetailsContext';
import OrderItemList from '../OrderItemList';

import './ProductList.scss';

const ProductList: FC = () => {
  const { orderItems } = useContext(OrderDetailsContext);

  return orderItems ? (
    <Accordion>
      <AccordionItem
        open={true}
        data-testid="paymentProductList"
        id="order-item-list"
        title={t('payment.payment_product_list', undefined, {
          numberOfProducts: '' + orderItems.length,
        })}
      >
        <OrderItemList items={orderItems} />
      </AccordionItem>
    </Accordion>
  ) : null;
};

export default ProductList;
